@if (mobileEntityHeader.template(); as compactHeader) {
  <div class="compact-entity-header">
    <ng-container *ngTemplateOutlet="compactHeader"/>
  </div>
}
<mat-toolbar class="header" [class.header-hidden]="!!mobileEntityHeader.template()">
  <div class="menu-wrapper">
    @if (mobileMode()) {
      <mat-icon svgIcon="hamburger-menu" class="menu-mobile" (click)="toggleSideNav()"></mat-icon>
    }
    @if (isProduction) {
      <a routerLink="/dashboard" class="logo-link">
        <img class="logo" ngSrc="../../../../assets/images/logo.svg" priority="true" width="81" height="32" alt="logo">
      </a>
    }
  </div>

  <app-crm-control-banner class="crm-controls"/>
  <div class="info-container">
    <button
      #notificationMenuTrigger="matMenuTrigger"
      mat-icon-button
      class="notification-button"
      [matMenuTriggerFor]="notificationsMenu"
      aria-label="Notifications"
    >
      <mat-icon svgIcon="notification" class="notification-icon"></mat-icon>
      @if (unreadCount() > 0) {
        <span class="notification-count">{{ unreadCount() > 9 ? '9+' : unreadCount() }}</span>
      }
    </button>
    <div class="user-info" [matMenuTriggerFor]="moreMenu">
      <img class="avatar" ngSrc="../../../../assets/images/Avatar.png" priority="true" width="38" height="38"
           alt="avatar">

      <div class="name-and-more">
        <div class="name">{{ user()?.username }}</div>
        <div matRipple class="more-icon-wrapper">
          <mat-icon svgIcon="more" class="more-icon"></mat-icon>
        </div>
      </div>
    </div>
  </div>

  <mat-menu #notificationsMenu="matMenu" class="mat-elevation-z8 notification-menu-panel">
    <div class="notification-menu" (click)="$event.stopPropagation()">
      <div class="notification-menu-title">
        <span>Notifications</span>
        <span class="notification-menu-unread-count">{{ unreadCount() }} new</span>
      </div>
      <div class="notification-list">
        @for (notification of notifications(); track notification.id) {
          <button class="notification-item" [class.unread]="notification.read_at === null" (click)="openNotification(notification)">
            <span class="notification-title">{{ notification.title || 'Notification' }}</span>
            <span class="notification-description">
              @for (line of notificationDescriptionLines(notification); track $index) {
                <span class="notification-description-line">
                  @if (line.label) {
                    <strong>{{ line.label }}</strong>@if (line.value) { {{ ' ' + line.value }} }
                  } @else {
                    {{ line.value }}
                  }
                </span>
              }
            </span>
            <small>{{ notification.created_at | date:'short' }}</small>
          </button>
        } @empty {
          <div class="notification-empty">No notifications</div>
        }
      </div>
      <button class="notification-view-all" (click)="viewAllNotifications()">View all</button>
    </div>
  </mat-menu>

  <mat-menu #moreMenu="matMenu" class="mat-elevation-z8">
    <div class="user-menu">
      <div class="user-info">
        <img class="avatar" ngSrc="../../../../assets/images/Avatar.png" priority="true" width="30" height="30"
             alt="avatar">
        <div>
          <div class="name">{{ user()?.username }}</div>
          <div class="email">{{ user()?.email }}</div>
        </div>
      </div>
      <mat-divider></mat-divider>
      @if (helpUrl(); as url) {
        <a mat-menu-item class="profile-menu-item help-link" [href]="url" target="_blank" rel="noopener noreferrer" aria-label="Help (opens in a new tab)">
          <mat-icon svgIcon="help-circle" aria-hidden="true"></mat-icon>
          <span>Help</span>
        </a>
      }
      @if (dashboardPreview.allowed()) {
        <button mat-menu-item class="profile-menu-item switch-dashboard" (click)="switchDashboard()">
          <mat-icon svgIcon="switch-dashboard" aria-hidden="true"></mat-icon>
          <span>Switch dashboard</span>
        </button>
      }
      @if (adminSession.allowed()) {
        <button mat-menu-item class="profile-menu-item admin-link" (click)="adminSession.open()">
          <mat-icon svgIcon="admin-panel" aria-hidden="true"></mat-icon>
          <span>Admin</span>
        </button>
      }
      <button mat-menu-item class="profile-menu-item logout" (click)="logout()">
        <mat-icon svgIcon="log-out" aria-hidden="true"></mat-icon>
        <span>Log out</span>
      </button>
    </div>
  </mat-menu>
</mat-toolbar>
